export default class SingleFooter {
  constructor() {

    // Only for desktop or higher ;-)
    if(!window.matchMedia('(min-width: 991px)').matches) {
      return;
    }

    this.container = document.getElementById('single-footer');

    // Check if container element exists
    if (!this.container) {
      return;
    }

    this.element = document.getElementById('single-footer__item');

    // Checkif item exists
    if (!this.element) {
      return;
    }

    this.offset = 0;

    this.updateVariables();
    this.updateWindow();
  }

  // Updating CSS variables
  updateVariables() {
    this.offset = this.container.offsetHeight - this.element.offsetHeight;
    document.documentElement.style.setProperty('--sidebar-offset', (this.offset + 72) + "px");
    document.documentElement.style.setProperty('--sidebar-offset-negative', -this.offset + "px");
  }

  // Triggered on updating the window
  updateWindow() {
    window.addEventListener('orientationchange', () => {
      this.updateVariables();
    });
    window.addEventListener('resize', () => {
      this.updateVariables();
    });
  }
}
